import { useEffect, useRef, useState } from "react";

const stats = [
  { value: 10, suffix: "+", label: "Schools Using VelTech" },
  { value: 5, suffix: "K+", label: "Students Managed" },
  { value: 80, suffix: "%", label: "Admin Time Saved" },
  { value: 98, suffix: "%", label: "Satisfaction Rate" },
];

function Counter({ target, suffix }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setInView(true); },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!inView) return;
    const steps = 50;
    const increment = target / steps;
    let current = 0;
    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, 30);
    return () => clearInterval(timer);
  }, [inView, target]);

  return (
    <span ref={ref}>
      {count.toLocaleString()}{suffix}
    </span>
  );
}

export default function Stats() {
  return (
    <section data-testid="stats-section" className="relative bg-gray-50 py-20 overflow-hidden">
      <div className="blob-emerald" style={{ top: '-30%', left: '50%', transform: 'translateX(-50%)' }} />
      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, i) => (
            <div
              key={stat.label}
              data-testid={`stat-${i}`}
              className="text-center p-8 bg-white border-2 border-gray-100"
            >
              <div
                className="text-4xl sm:text-5xl font-black text-[#0A0A0A] mb-2"
                style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
              >
                <Counter target={stat.value} suffix={stat.suffix} />
              </div>
              <div
                className="text-sm text-gray-500 font-bold uppercase tracking-wider"
                style={{ fontFamily: "'Satoshi', sans-serif" }}
              >
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
